import {Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CoreSidebarService} from '../../../../@core/components/core-sidebar/core-sidebar.service';
import {AlertService} from '../../../shared/services/alert.service';
import {HttpClient} from '@angular/common/http';
import {GlobalService} from '../../../shared/services/global.service';
import {UniversityService} from '../../../shared/services/university.service';

@Component({
    selector: 'app-add-university',
    templateUrl: './add-university.component.html',
    styleUrls: ['./add-university.component.scss']
})
export class AddUniversityComponent implements OnChanges {
    addUniversityForm: FormGroup;
    id: any;
    inputTypePassword: any = 'password';
    submitted: any = false;
    submitting: any = false;
    @Output() valueSubmitted = new EventEmitter<any>();
    @Input() data: any;

    constructor(private _coreSidebarService: CoreSidebarService,
                private fb: FormBuilder,
                private alertService: AlertService,
                public http: HttpClient,
                public globalService: GlobalService,
                public universityService: UniversityService) {
    }

    ngOnChanges(): void {
        this.refresh();
    }

    toggleSidebar(): void {
        this._coreSidebarService.getSidebarRegistry('add-university').toggleOpen();
    }

    refresh() {
        this.addUniversityForm = this.fb.group({
            'name': ['', Validators.required],
            'short_name': [''],
        });
        if (this.data && this.data['id']) {
            this.patchForm();
        }
    }

    patchForm() {
        this.addUniversityForm.patchValue({
            'name': (this.data && this.data['name']) ? this.data['name'] : '',
            'short_name': (this.data && this.data['short_name']) ? this.data['short_name'] : '',
        });
    }

    submit() {
        this.submitted = true;
        if (!this.addUniversityForm.valid) {
            return;
        }
        if (this.submitted) {
            const params = {
                'name': (this.addUniversityForm.value && this.addUniversityForm.value.name) ? this.addUniversityForm.value.name : '',
                'short_name': (this.addUniversityForm.value && this.addUniversityForm.value.short_name) ? this.addUniversityForm.value.short_name : '',
            };
            this.submitting = true;
            this.universityService.create(params).subscribe(data => {
                if (data) {
                    this.submitting = false;
                    this.submitted = false;
                    this.valueSubmitted.emit(true);
                    this.addUniversityForm.reset();
                    this.addUniversityForm.patchValue({
                        'name': '',
                        'short_name': '',
                    });
                }
            }, error => {
                this.submitting = false;
                this.submitted = false;
                if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
                    if (error['error']['errors'].name && error['error']['errors'].name.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].name[0]);
                        return;
                    }
                }
            });
        }
    }

    update() {
        this.submitted = true;
        if (!this.addUniversityForm.valid) {
            return;
        }
        if (this.submitted) {
            const params = {
                'name': (this.addUniversityForm.value && this.addUniversityForm.value.name) ? this.addUniversityForm.value.name : '',
                'short_name': (this.addUniversityForm.value && this.addUniversityForm.value.short_name) ? this.addUniversityForm.value.short_name : '',
            };
            this.submitting = true;
            this.universityService.update(this.data['unique_id'], params).subscribe(data => {
                this.submitting = false;
                this.submitted = false;
                this.valueSubmitted.emit(true);
            }, error => {
                this.submitting = false;
                this.submitted = false;
                if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
                    if (error['error']['errors'].name && error['error']['errors'].name.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].name[0]);
                        return;
                    }
                }
            });
        }
    }
}
